import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-hero-blue-floatee-item.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
var BannerHeroBlueFloateeItem = /** @class */ (function (_super) {
    tslib_1.__extends(BannerHeroBlueFloateeItem, _super);
    function BannerHeroBlueFloateeItem(element) {
        var _this = _super.call(this, element) || this;
        _this.w = 1200;
        _this.h = 480; // initial height of the image
        _this.ratio = _this.w / _this.h;
        return _this;
    }
    BannerHeroBlueFloateeItem.prototype.init = function () {
        this.imageHolder = this.element.querySelector('.banner-hero-blue-floatee-item__image-holder');
        this.contentBackground = this.element.querySelector('.banner-hero-blue-floatee-item__content-background');
    };
    BannerHeroBlueFloateeItem.prototype.bindEvents = function () {
        // Uncomment the following line to bind the resize event
        // window.addEventListener('resize', this.onResize.bind(this));
    };
    BannerHeroBlueFloateeItem.prototype.onResize = function () {
        var ww = window.innerWidth;
        var el = this.element;
        el.style.opacity = '1';
        var allBanners = document.querySelectorAll('.banner-hero-blue-floatee-item'); // Select all banners
        var maxHeight = 0; // To store the max height across all banners
        // Iterate over each banner and find the tallest one
        allBanners.forEach(function (banner) {
            var imageHolder = banner.querySelector('.banner-hero-blue-floatee-item__image-holder');
            var contentBackground = banner.querySelector('.banner-hero-blue-floatee-item__content-background');
            // Check the height of the content background and image holder
            var totalHeight = imageHolder.offsetHeight + contentBackground.offsetHeight;
            // Update maxHeight if the current banner is taller
            maxHeight = Math.max(maxHeight, totalHeight);
        });
        if (ww > this.w) {
            var bannerHeight = ww / this.ratio;
            var colWidth = this.w / 12;
            var cbWidth = ((ww - (12 * colWidth)) / 2) + (4 * colWidth);
            this.contentBackground.style.width = cbWidth + 'px';
            this.contentBackground.style.height = bannerHeight + 'px';
        }
        else {
            this.contentBackground.style.removeProperty('height');
            if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {
                this.contentBackground.style.width = '100%';
                this.imageHolder.style.height = this.imageHolder.querySelector('img').offsetHeight + 'px';
                // Set the height of the blue box based on the tallest banner on mobile
                this.imageHolder.style.height = maxHeight + "px";
            }
            else if (MediaQueryService.getMediaQuery() === 'medium') {
                this.imageHolder.style.removeProperty('height');
                var colWidth = ww / 12;
                this.contentBackground.style.width = (5 * colWidth) + 'px';
            }
            else {
                this.imageHolder.style.removeProperty('height');
                var colWidth = ww / 12;
                this.contentBackground.style.width = (4 * colWidth) + 'px';
            }
        }
    };
    return BannerHeroBlueFloateeItem;
}(Base));
export { BannerHeroBlueFloateeItem };



//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-blue-floatee-item/banner-hero-blue-floatee-item.component.ts
// module id = 126
// module chunks = 0